// extracted by mini-css-extract-plugin
export default {"container":"jA-z","brandName":"kA-z","productName":"lA-z","aboveGalleryInfo":"mA-z","belowGalleryInfo":"nA-z","breakLongProductName":"oA-z"};